'use strict';

var NetSpillRateGridDirective = function NetSpillRateGridDirective() {
  return {
    restrict: 'E',
    template: require('../templates/net-spill-rate-grid.html'),
    scope: {
      data: '=',
      avgFareLabel: '@'
    }
  };
};
NetSpillRateGridDirective.$inject = [];
module.exports = NetSpillRateGridDirective;